import type { LanguageCode } from '__generated__/graphql-types';

import { filterUndefined } from 'bundles/common/utils/commonUtils';
import { joinWithAnd } from 'bundles/enterprise-legacy-learner-home/utils/skillsClipsUtils';
import { SOCIAL_MEDIA_ICON_URLS } from 'bundles/page-footer/components/global-footer/constants';
import type { AuthorProfile } from 'bundles/shared-articles/components/ArticleAuthorProfile';
import { FIRST_PAGE_NUMBER } from 'bundles/shared-articles/constants';

export const isValidPageNumber = (pageNumber: number, pageCount: number): boolean => {
  if (pageNumber > pageCount || pageNumber < FIRST_PAGE_NUMBER) return false;
  return true;
};

export const getPageNumberFromString = (page: string): number => {
  return !isNaN(parseInt(page, 10)) ? parseInt(page, 10) : 1;
};

export const getSocialPlatformInfo = (url: string) => {
  const link = new URL(url);
  const platformName = Object.keys(SOCIAL_MEDIA_ICON_URLS).find((platform) => link.hostname.includes(platform));
  let displayUrl = platformName ? link.pathname.slice(1) : url.replace(/(https?:\/\/)/g, '');
  displayUrl = displayUrl.endsWith('/') ? displayUrl.slice(0, -1) : displayUrl;

  return {
    displayUrl,
    socialPlatform: platformName,
  };
};

export const validateExternalUrl = (url: string) => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$',
    'i'
  );
  return !!urlPattern.test(url);
};

export const getListOfAuthorNames = (authors?: AuthorProfile[]) => {
  const names = authors?.map((author) => author?.name ?? '').filter(filterUndefined) ?? [];
  return joinWithAnd(names);
};

export const getLanguageCodeFromCountryCode = (countryCode: string): LanguageCode => {
  switch (countryCode.toLowerCase()) {
    case 'mx':
      return 'es';
    case 'fr':
      return 'fr';
    case 'de':
      return 'de';
    case 'ca':
    case 'in':
    case 'gb':
    case 'global':
    default:
      return 'global';
  }
};
